export const PLATFORM_SUPER_ADMIN = "PLATFORM_SUPER_ADMIN";

export enum PLATFORM_AGILE_ROLES {
  AGILE_ADMIN = "PLATFORM_AGILE_ADMIN",
  AGILE_REGIONAL_LEAD = "PLATFORM_AGILE_REGIONAL_LEAD",
  AGILE_ADVANCED_FLEXPERT_SUPPORT = "PLATFORM_AGILE_ADVANCED_FLEXPERT_SUPPORT",
}

export enum FAST_MK2_ROLES {
  SUPER_ADMIN = "FAST_MK2_SUPER_ADMIN",
  ADMIN = "FAST_MK2_ADMIN",
  FLEXPERT = "FAST_MK2_FLEXPERT",
  FLEXPERT_SUPPORT = "FAST_MK2_FLEXPERT_SUPPORT",
  PROVIDER_INVENTORY_MANAGER = "FAST_MK2_PROVIDER_INVENTORY_MANAGER",
  CLIENT = "FAST_MK2_CLIENT",
}

export enum PLATFORM_AGILE_ADMIN_PERMISSIONS {
  CREATE_AGILE_USERS = "PLATFORM_CAN_CREATE_AGILE_USERS",
  DEACTIVATE_AGILE_USERS = "PLATFORM_CAN_DEACTIVATE_AGILE_USERS",
  LIST_AGILE_USERS = "PLATFORM_CAN_LIST_AGILE_USERS",
  UPDATE_AGILE_USERS = "PLATFORM_CAN_UPDATE_AGILE_USERS",
  READ_ONLY = "PLATFORM_READ_ONLY",
}

export enum PLATFORM_AGILE_REGIONAL_LEAD_PERMISSIONS {
  CREATE_FLEXPERT_USERS = "PLATFORM_CAN_CREATE_AGILE_FLEXPERT_USERS",
  DEACTIVATE_FLEXPERT_USERS = "PLATFORM_CAN_DEACTIVATE_AGILE_FLEXPERT_USERS",
  LIST_FLEXPERT_USERS = "PLATFORM_CAN_LIST_AGILE_FLEXPERT_USERS",
  UPDATE_FLEXPERT_USERS = "PLATFORM_CAN_UPDATE_AGILE_FLEXPERT_USERS",
  READ_ONLY = "PLATFORM_READ_ONLY",
}

export enum PLATFORM_AGILE_ADVANCED_FLEXPERT_SUPPORT_PERMISSIONS {
  CREATE_FLEXPERT_SUPPORT_USERS = "PLATFORM_CAN_CREATE_AGILE_FLEXPERT_SUPPORT_USERS",
  DEACTIVATE_FLEXPERT_SUPPORT_USERS = "PLATFORM_CAN_DEACTIVATE_AGILE_FLEXPERT_SUPPORT_USERS",
  LIST_FLEXPERT_SUPPORT_USERS = "PLATFORM_CAN_LIST_AGILE_FLEXPERT_SUPPORT_USERS",
  UPDATE_FLEXPERT_SUPPORT_USERS = "PLATFORM_CAN_UPDATE_AGILE_FLEXPERT_SUPPORT_USERS",
  READ_ONLY = "PLATFORM_READ_ONLY",
}
